/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_RECIPIENT_LIST (state, val) {
      state.recipientList = val
    },
    UPDATE_RECIPIENT_LIST (state, val) {
      state.recipientList.push(...val)
    },
    ADD_RECIPIENT(state, val) {
      state.recipientList.unshift(val)
    },
    UPDATE_RECIPIENT (state, val) {
      const i = state.recipientList.findIndex(i => i.RecipientId == val.RecipientId)
      Object.assign(state.recipientList[i], val)
    },
  }
  